const initialState = {};

const registerProductReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_REGISTER_PRODUCT_DATA':
      return { ...state, ...action.payload };
    case 'CLEAR_REGISTER_PRODUCT_DATA':
      return initialState;
    default:
      return state;
  }
};

export default registerProductReducer;
